import React from "react";
import styles from "./LocationTableHeader.module.css";
import {useAppDispatch, useAppSelector} from "../../../../../app/hooks";
import {LocationTableSortingField} from "../../../../../api/generated";
import {SortableHeaderCell, TableSort} from "../../../../elements/sortableHeaderCell/SortableHeaderCell";
import {locationTableRequestSelector, updateLocationTableRequest} from "../../locationListSlice";

export const LocationTableHeader: React.FC = () => {
    const dispatch = useAppDispatch()
    const {sortBy, sortDirection} = useAppSelector(locationTableRequestSelector)
    const sort: TableSort<LocationTableSortingField> = {sortBy, sortDirection}

    const handleSort = (nextSort: TableSort<LocationTableSortingField>) => {
        dispatch(updateLocationTableRequest(nextSort))
    }

    return <div className={styles.wrapper}>
        <SortableHeaderCell className={styles.locationIdCell} title={"Location ID"} sortKey={LocationTableSortingField.PublicId} sort={sort} onSort={handleSort}/>
        <SortableHeaderCell className={styles.nameCell} title={"Name"} sortKey={LocationTableSortingField.Name} sort={sort} onSort={handleSort}/>
        <SortableHeaderCell className={styles.cityCell} title={"City"} sortKey={LocationTableSortingField.City} sort={sort} onSort={handleSort}/>
        <SortableHeaderCell className={styles.postcodeCell} title={"Postcode"} sortKey={LocationTableSortingField.Postcode} sort={sort} onSort={handleSort}/>
        <span className={styles.actionsCell}>Actions</span>
    </div>
}
